/*
 * @Description:
 * @Author: 琢磨先生
 * @Date: 2024-03-13 09:06:34
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-04-03 16:37:39
 */
import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
import "element-plus/theme-chalk/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import * as ElIcons from "@element-plus/icons-vue";
import "nprogress/nprogress.css";
import "@/assets/app.css";
import router from "./router/router";
import http from "./http/http";
import config from "./plugins/in_config";
import power from "./plugins/power";
import * as qdaComponents from "./components";

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

const app = createApp(App);
app.use(router);
app.use(http);
app.use(config);
app.use(power);

app.use(ElementPlus, { locale: zhCn });

for (const [key, component] of Object.entries(ElIcons)) {
  app.component(key, component);
}

for (const [key, component] of Object.entries(qdaComponents)) {
  app.component(key, component);
}

app.mount("#app");
